import { Stack, useTheme } from "@mui/material";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { DetailSectionHeader } from "web_myplann/Portfolio/Components/Redesign/Detail/DetailSectionHeader";
import { ToolHistoryRow } from "web_myplann/Portfolio/Components/Redesign/Detail/FundDetail/ToolHistoryRow";
import { useToolHistoryItems } from "web_myplann/Portfolio/Components/Redesign/Detail/FundDetail/useToolHistoryItems";
import type { NormalizedTool } from "web_myplann/Portfolio/Helpers/investmentToolTypes";

type Props = {
	tool: NormalizedTool;
	currencySign: string;
};

export const ToolHistorySection: FC<Props> = ({ tool, currencySign }) => {
	const { t } = useResource();
	const theme = useTheme();
	const items = useToolHistoryItems(tool, currencySign);

	if (items.length === 0) {
		return null;
	}

	return (
		<Stack mt={1}>
			<DetailSectionHeader
				title={t(Resources.PortfolioDetail.ToolHistory.title)}
			/>
			<Stack bgcolor={theme.palette.background.paper}>
				{items.map((item, index) => (
					<ToolHistoryRow
						key={item.id}
						item={item}
						isLast={index === items.length - 1}
					/>
				))}
			</Stack>
		</Stack>
	);
};
